import React from 'react';
import styled from 'styled-components';
import { Paragraph } from '@agilytics/components';

const SubTextContainer = styled(Paragraph)`
  font-size: 12px;
`;

export default function SubText(props) {
  return <SubTextContainer>{props.children}</SubTextContainer>;
}
